import { render, staticRenderFns } from "./intranetClueCarRecordItem.vue?vue&type=template&id=8447e464&scoped=true"
import script from "./intranetClueCarRecordItem.vue?vue&type=script&lang=js"
export * from "./intranetClueCarRecordItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8447e464",
  null
  
)

export default component.exports